import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../services/auth.service';
import { FirebaseDataService } from '../../../services/firebase-data.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {
  contactForm: FormGroup;
  loading: boolean = false;
  responseRecevied: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private toastr: ToastrService,
              public auth: AuthService,
              private dbService: FirebaseDataService) {
    this.contactForm = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, Validators.maxLength(20)]),
      lastname: new FormControl('', [Validators.required, Validators.maxLength(20)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      comment: new FormControl('', [Validators.required, Validators.maxLength(300)])
    });
    // this.auth.user$.subscribe( (user) => {
    //   if (user === null) {
    //     this.loggedIn = false;
    //   } else {
    //     this.loggedIn = true;
    //     this.loggedInUserPhoto = user.photoURL;
    //     this.loggedInUserName = user.displayName;
    //     this.contactForm.controls.userName.setValue(user.displayName);
    //     this.contactForm.controls.userEmail.setValue(user.email);
    //   }
    // });
   }

  onSubmit(userComment): void {
    this.loading = true;
    this.dbService.insertUserComment(userComment);
    setTimeout(() => {
      this.loading = false;
      this.responseRecevied = true;
      console.warn('User Comment sent', userComment);
    }, 2000);
  }

  anotherResponse() {
    this.contactForm.reset();
    this.responseRecevied = false;
  }

}
